<template>
  <div class="app-container">
    <!-- 主要内容 -->
    <router-view v-slot="{ Component }">
      <Transition name="page" mode="out-in">
        <component :is="Component" />
      </Transition>
    </router-view>

    <!-- 全局Loading组件 -->
    <LoadingScreen :visible="globalLoading.isLoading.value" :duration="3000" :min-duration="500"
      @complete="globalLoading.stop" />
  </div>
</template>

<script setup lang="ts">
import { useColorMode } from "@vueuse/core";
import { onMounted } from "vue";
import LoadingScreen from "@/components/LoadingScreen.vue";
import { globalLoading } from "@/composables/usePageLoading";

// 恢复useColorMode，确保默认为light主题
// SSR时不使用localStorage
const mode = useColorMode({
  attribute: 'class',
  modes: {
    dark: 'dark',
    light: '',
  },
  storageKey: 'vueuse-color-scheme',
  storage: import.meta.env.SSR ? undefined : localStorage,
  initialValue: 'light', // 设置默认值为light
});

// 确保在组件挂载时主题正确初始化
onMounted(() => {
  console.log('📱 App组件挂载 - 当前主题:', mode.value);
});
</script>

<style scoped>
/* 页面切换动画 */
.page-enter-active,
.page-leave-active {
  transition: all 0.3s ease;
}

.page-enter-from {
  opacity: 0;
  transform: translateX(20px);
}

.page-leave-to {
  opacity: 0;
  transform: translateX(-20px);
}

.app-container {
  position: relative;
  min-height: 100vh;
}
</style>